import React, { useState } from "react";
import categories from "../Data/Categories";
import companyData from "../Data/CompanyData";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { cn } from "../lib/utils";

const RegisterModal = ({
  isOpen,
  onClose,
  selectedOption,
  setSelectedOption,
  title,
}) => {
  const [tempSelectedOption, setTempSelectedOption] = useState(selectedOption);

  const [visibleOptions, setVisibleOptions] = useState(10); // Número inicial de opciones visibles

  const handleShowMore = () => {
    setVisibleOptions((prev) => prev + 10); // Incrementa el número de opciones visibles en 10
  };

  const handleOptionSelect = (option) => {
    setTempSelectedOption(option);
  };

  const handleApply = () => {
    setSelectedOption(tempSelectedOption);
    onClose();
  };

  // Filtrar las categorías excluyendo "Otro Servicio"
  const filteredCategories = categories.filter(
    (category) => category.label !== "Otro Servicio"
  );

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="grid max-h-96 grid-cols-2 gap-2 overflow-y-auto sm:grid-cols-3">
          {/* Mostrar primero las categorías filtradas */}
          {filteredCategories.slice(0, visibleOptions).map((category) => (
            <button
              key={category.label}
              type="button"
              onClick={() => handleOptionSelect(category.label)}
              className={cn(
                "flex flex-col items-center gap-1 rounded-md border border-border p-3 text-center text-sm hover:bg-muted",
                tempSelectedOption === category.label &&
                  "border-primary bg-primary/10 text-primary"
              )}
            >
              {category.icon && <span className="text-xl">{category.icon}</span>}
              <span>{category.label}</span>
            </button>
          ))}

          {/* Mostrar luego los sectores de companyData */}
          {companyData.sectores
            .slice(0, visibleOptions - filteredCategories.length)
            .map((sector) => (
              <button
                key={sector.label}
                type="button"
                onClick={() => handleOptionSelect(sector.label)}
                className={cn(
                  "flex flex-col items-center gap-1 rounded-md border border-border p-3 text-center text-sm hover:bg-muted",
                  tempSelectedOption === sector.label &&
                    "border-primary bg-primary/10 text-primary"
                )}
              >
                {sector.icon && <span className="text-xl">{sector.icon}</span>}
                <span>{sector.label}</span>
              </button>
            ))}

          {/* Botón "Ver más" */}
          {visibleOptions <
            filteredCategories.length + companyData.sectores.length && (
            <button
              type="button"
              onClick={handleShowMore}
              className="col-span-2 rounded-md border border-dashed border-border p-3 text-sm text-muted-foreground hover:bg-muted sm:col-span-3"
            >
              Ver más
            </button>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => setTempSelectedOption("")}>
            Limpiar
          </Button>
          <Button onClick={handleApply}>Seleccionar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RegisterModal;
